import React from "react";
import { VectorMap } from "react-jvectormap";

function getElementSize(node) {
    if (!node) {
        return { width: 0, height: 0 };
    }

    const rect = node.getBoundingClientRect();
    return {
        width: Math.max(0, Math.round(rect.width)),
        height: Math.max(0, Math.round(rect.height)),
    };
}

export default function SafeVectorMap({
    containerStyle,
    minWidth = 48,
    minHeight = 48,
    ...vectorMapProps
}) {
    const shellRef = React.useRef(null);
    const [size, setSize] = React.useState({ width: 0, height: 0 });

    React.useLayoutEffect(() => {
        const node = shellRef.current;
        if (!node) return undefined;

        const syncSize = () => {
            setSize((prev) => {
                const next = getElementSize(node);
                if (prev.width === next.width && prev.height === next.height) {
                    return prev;
                }
                return next;
            });
        };

        syncSize();

        if (typeof ResizeObserver !== "undefined") {
            const observer = new ResizeObserver(syncSize);
            observer.observe(node);
            return () => observer.disconnect();
        }

        window.addEventListener("resize", syncSize);
        return () => window.removeEventListener("resize", syncSize);
    }, []);

    const isReady = size.width >= minWidth && size.height >= minHeight;

    return (
        <div ref={shellRef} style={{ width: "100%", height: "100%" }}>
            {isReady ? (
                <VectorMap
                    key={`${size.width}x${size.height}`}
                    containerStyle={{
                        width: "100%",
                        height: "100%",
                        ...(containerStyle || {}),
                    }}
                    {...vectorMapProps}
                />
            ) : (
                <div style={{ width: "100%", height: "100%" }} />
            )}
        </div>
    );
}
